exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#info-dialg {\n  z-index: 1000;\n  background-color: #006622;\n  position: fixed;\n  top: 10%;\n  right: 0px; }\n", "", {"version":3,"sources":["/Users/jean-philippe/_work/rs-webapp/rs-lightbox-old/client/app/ui/info-dialog/info-dialog.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,WAAW,EAAE","file":"info-dialog.scss","sourcesContent":["#info-dialg {\n  z-index: 1000;\n  background-color: #006622;\n  position: fixed;\n  top: 10%;\n  right: 0px; }\n"],"sourceRoot":""}]);

// exports
